import axios from 'axios';
import { ajaxUri } from '../../../consts/index';
import { l } from '../../../functions';

export const fetchCategories = (loadIncrement = null) => {
    return dispatch => {
		axios({
			method: 'post',
			url: ajaxUri,
			data: {
				request : 'listCategories'
			}
		})
		.then(result => {
            const categoriesArray = [];
            for (const category of result.data || []) categoriesArray[category.id] = category;

            if( loadIncrement ) dispatch({type:'LOAD_INCREMENT',toAdd:parseInt(loadIncrement)/2})

            dispatch({type:'LIST_CATEGORIES',target:'normal',categories:categoriesArray});
		}).catch(error => {
			console.error(l('Cannot fetch categories'))
        });

		axios({
			method: 'post',
			url: ajaxUri,
			data: {
				request : 'listCategoriesLeveled'
			}
		})
		.then(result => {
            if( loadIncrement ) dispatch({type:'LOAD_INCREMENT',toAdd:parseInt(loadIncrement)/2})
            
            dispatch({type:'LIST_CATEGORIES',target:'leveled',categories:result.data});
		}).catch(error => {
			console.error(l('Cannot fetch categories (leveled)'))
        });
    }
}